import {
  Clock,
  DeviceTabletCamera,
  Hourglass,
  LinkSimple,
  Notepad,
  PaperPlaneTilt,
  WarningCircle,
} from '@phosphor-icons/react'
import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

type Props = {
  type:
    | 'scheduled'
    | 'internal'
    | 'sent'
    | 'received'
    | 'pending'
    | 'tablet'
    | 'kiosk'
    | 'public'
    | 'failed'
    | 'queued'
    | 'pre-fill'
} & HTMLAttributes<HTMLDivElement>

export const MessageStatus = ({
  type,
  className,
  children,
  ...props
}: Props) => {
  const statusStyles = {
    'bg-gray-100 text-gray-600': type === 'internal',
    'bg-blue-100 text-blue-900': ['scheduled', 'received'].includes(type),
    'bg-green-100 text-green-900': [
      'sent',
      'tablet',
      'kiosk',
      'public',
    ].includes(type),
    'bg-orange-100 text-orange-900': ['pending', 'queued'].includes(type),
    'bg-red-100 text-red-900': type === 'failed',
    'bg-purple-100 text-purple-900': type === 'pre-fill',
  }
  const statusIcon = {
    internal: <Notepad className="text-base text-gray-600" />,
    received: <></>,
    sent: <PaperPlaneTilt className="fill-green-900 text-base" />,
    scheduled: <Clock className="fill-blue-900 text-base" />,
    pending: <Hourglass className="fill-orange-900 text-base" />,
    tablet: <DeviceTabletCamera className="fill-green-900 text-base" />,
    kiosk: <DeviceTabletCamera className="fill-green-900 text-base" />,
    public: <LinkSimple className="fill-green-900 text-base" />,
    failed: <WarningCircle className="fill-red-600 text-base" weight="fill" />,
    queued: <Hourglass className="fill-orange-900 text-base" />,
    'pre-fill': <Hourglass className="fill-purple-900 text-base" />,
  }
  return (
    <div
      className={cn(
        'flex w-[fit-content] cursor-default items-center gap-1 rounded-3xl bg-blue-100 px-2 py-1 text-xs text-blue-900',
        statusStyles,
        className
      )}
      {...props}
    >
      {statusIcon[type]}
      {children}
    </div>
  )
}
